// extracted by mini-css-extract-plugin
export var disabled = "_2g-5";
export var fileName = "_2g-b";
export var filePreview = "_2g-4";
export var hoverFilter = "_2g-6";
export var imageButton = "_2g-3 _2g-6";
export var imageButtonContainer = "_2g-2";
export var input = "_2g-7";
export var removeButton = "_2g-0";
export var removeButtonFile = "_2g-1";
export var spinner = "_2g-9";
export var spinnerContainer = "_2g-8";
export var videoContainer = "_2g-a _2g-6";